import { IAuth as Auth } from "../../models/auth";

export enum ActionType {
  AUTH_START = "AUTH_START",
  AUTH_SUCCESS = "AUTH_SUCCESS",
  AUTH_FAIL = "AUTH_FAIL",
  //   DO_GOOGLE_AUTH = 'DO_GOOGLE_AUTH',
  DO_LOGOUT = "DO_LOGOUT",
  DO_SIGNIN = "DO_SIGNIN",
  //   DO_SIGNUP = "DO_SIGNUP"
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
  REMEMBER_PASSWORD = "REMEMBER_PASSWORD",
}

export interface IAuthStart {
  type: ActionType.AUTH_START;
}

export interface IAuthSuccess {
  type: ActionType.AUTH_SUCCESS;
  payload: Auth;
}

export interface IAuthSuccessResponse {
  access_token: string;
  refresh_token: string;
  TokenType: string;
  data: {
    user: IUserInLoginResponse;
  };
}
export interface IUserInLoginResponse {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  status: string;
  type: string;
}

export interface IAuthFailPayload {
  code: string | null;
  message: string | null;
}

export interface IAuthFail {
  type: ActionType.AUTH_FAIL;
  payload: IAuthFailPayload | null;
}

export interface ILogout {
  type: ActionType.DO_LOGOUT;
}

export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}

export interface IRememberPassword {
  type: ActionType.REMEMBER_PASSWORD;
  payload: { username: string; password: string };
}

export type Action = IAuthStart | IAuthSuccess | IAuthFail | ILogout | IResetReduxState | IRememberPassword;
